import { getTranslations } from 'next-intl/server'
import { Locale } from '@/i18n/types'

async function getFundraisingEventPageTitle(fundraisingEventName: string, manager: string, locale: Locale) {
  const t = await getTranslations({ locale, namespace: 'nextjs.receiver_pages.fundraising_event' })
  const title = t('page_title', {
    fundraisingEventName,
    manager,
  })

  return title
}

export default getFundraisingEventPageTitle
